<div class="boxWhite">
  <h4 class="clRed">DESHACER FINALIZAR JORNADA</h4>

  <button class="btn btnClose" (click)="closeModal()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="contModal">
    <p>¿Estas seguro que quieres deshacer <strong>Finalizar Jornada</strong>?</p>
    <div class="row">
      <div class="col-sm-5">
        <h6 class="clBlack">ID</h6>
        <p class="clGray mb-4">{{conductor.visibleId}}</p>
      </div>

      <div class="col-sm-7">
        <h6 class="clBlack">NOMBRE CONDUCTOR</h6>
        <p class="clGray mb-4">{{conductor.nombres}} {{conductor.apellidoPaterno}}</p>
      </div>

      <div class="col-sm-5">
        <h6 class="clBlack">HORA</h6>
        <p class="clGray mb-4">{{formatHoraInicioPlanificado(conductor.jornadaEnCurso)}}</p>
      </div>
      <div class="col-sm-7">
        <h6 class="clBlack">SUCURSAL ORIGEN</h6>
        <p class="clRed mb-4 fw-medium">{{conductor.sucursalActual?.nombre}}</p>
      </div>
    </div>
  </div>

  <div class="footModal">
    <button *ngIf="tienePermisoDeshacerFinJornada()" class="btn btnRed w-100" (click)="deshacer()">DESHACER FINALIZAR</button>
  </div>
</div>
